import React, {useEffect, useState} from 'react';
import {OwlCarouselSlider2} from '../../component/slider/index';

import Api from "../../interface/api/site";


export default function Gate(props) {

    const [ siteInfos, setSiteInfos ] = useState([]);

    const [ site1, setSite1 ] = useState<Array<any>>([]);
    const [ site2, setSite2 ] = useState<Array<any>>([]);
    const [ site3, setSite3 ] = useState<Array<any>>([]);
    const [ site4, setSite4 ] = useState<Array<any>>([]);

    function indexMoveHandler() {
        // props.history.push(`/${JSON.parse(localStorage.getItem('siteInfo')).seq}/visit/`);
        if( localStorage.getItem('siteInfo') === null ) {
            alert('사업장을 선택해주세요.');
            return false;
        }
        props.history.push(`/visit/`);
        // window.location.href = '/visit';
    }

    useEffect(() => {
        localStorage.clear();
        Api.siteInfoList().then(res => {
            setSiteInfos(res.data);
            for(let i =0; i< res.data.length; i++) {
                if(i==0) {
                    setSite1(res.data[i].childrenSiteInfos)
                }
                if(i==1) {
                    setSite2(res.data[i].childrenSiteInfos)
                }
                if(i==2) {
                    setSite3(res.data[i].childrenSiteInfos)
                }
                if(i==3) {
                    setSite4(res.data[i].childrenSiteInfos)
                }
            }
            // setSiteInfos(res.data);
        });
    }, [])

    return (
        <>
            <div className="user nv_wrap nv_gate">
                <div className="nv_gate_header">
                    <header>
                        <h1 className="nv_logo"><a href="/visit/gate">방문예약시스템</a></h1>
                    </header>
                </div>
                <div className="nv_main_banner">
                    <div className="on"><img src="/resource/user/images/gate_01.jpg" alt="" className="nv_img"/></div>
                    <div><img src="/resource/user/images/gate_02.jpg" alt="" className="nv_img"/></div>
                    <div><img src="/resource/user/images/gate_03.jpg" alt="" className="nv_img"/></div>
                    <div><img src="/resource/user/images/gate_04.jpg" alt="" className="nv_img"/></div>
                </div>
                <div className="nv_contents">
                    <h2 className="nv_gate_tit">
                        <span className="nv_blue">솔브레인</span><br/>
                        방문예약시스템
                    </h2>
                    <p className="nv_info">방문하실 사업장을 선택해주세요.</p>
                    <OwlCarouselSlider2>
                        {
                            siteInfos.map((row, index) => (
                                <div key={`siteInfosKey-${index}`}>
                                    <div className="m_slide pc_skip tpc_skip m_skip">
                                        <img src={`/resource/user/images/gate_0${index+1}.jpg`} alt="" className="nv_img"/>
                                    </div>
                                    <div className="nv_site">
                                        <p className="nv_en">{row.englishName}</p>
                                        <h2 className="nv_name">{row.name}</h2>
                                        <div className="site_select_wrap">
                                            <div className="site_select">
                                                <p className="selectTit">선택</p>
                                                <ul>
                                                    {
                                                        row.childrenSiteInfos.map((row2, index2) => (
                                                            row2.name !== 'FECT' &&
                                                            <li key={`childrenSiteInfosKey-${index2}`}
                                                                onClick={() => localStorage.setItem('siteInfo', JSON.stringify(row2))}
                                                            >{row2.name}</li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                            <button type="button" className="btn_gate" onClick={indexMoveHandler}>이동</button>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </OwlCarouselSlider2>
                </div>
            </div>
        </>
    )
}